var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"digit tw-flex tw-text-center tw-items-center tw-justify-center tw-rounded-md tw-mr-1/4 tw-py-1/4",class:_vm.color},[_vm._v(" "+_vm._s(_vm.digit)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }